import React, { Component } from 'react';
import BrowserStorageLocationField from './BrowserStorageLocationField';

class BrowserStoragePayload extends Component {
  render() {
    const {
      values,
      setFieldValue,
      setFieldTouched,
      fieldName,
      description,
      isMulti = true,
      label,
      placeholder,
      showDefaultOption = true,
      infoDescription,
    } = this.props;

    return (
      <BrowserStorageLocationField
        fieldName={fieldName || 'bslPayload'}
        values={values}
        infoDescription={
          infoDescription ||
          description ||
          'Select a browser storage locations from where you want to send data as a payload to Custom Function.'
        }
        description={
          description || 'Select a browser storage locations data to be sent to Custom Function.'
        }
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
        isMulti={isMulti || false}
        label={label || 'Send Browser Storage Data'}
        placeholder={placeholder || '(Optional)'}
        showDefaultOption={showDefaultOption || false}
      />
    );
  }
}

export default BrowserStoragePayload;
